<template>
  <div>
    <!-- 左上 -->
    <div
      style="
        position: absolute;
        width: 500px;
        height: 242px;
        top: 0px;
        left: 10px;
      "
    >
      <dv-border-box-1 backgroundColor="rgba(7,11,32,.7)">
        <p
          style="
            color: #fccc66;
            font-size: 18px;
            padding: 20px 0 8px 24px;
            margin: 0;
          "
        >
          产业概况
        </p>
        <p
          style="
            color: #9cd9fc;
            padding: 0 24px 24px 24px;
            font-size: 16px;
            margin: 0;
          "
        >
          长丰县是我国著名的优质草莓生产基地，先后荣获“中国草莓之都”、“中国设施草莓第一县”、“国家地理标志商标”、“首批全国农业全产业链典型县”等八项国字号荣誉。
          其中“艳九天”、“蝶恋花”品牌荣获“全国十大好吃草莓”称号。全县辐射草莓面积21万亩，种植户8万多户、从业人员18万，亩均增收2.3万元；总产量超35万吨，全产业链产值破110亿元，品牌价值102.2亿元。
        </p>
      </dv-border-box-1>
    </div>

    <!-- 左下 -->
    <div
      style="
        position: absolute;
        width: 300px;
        top: 244px;
        bottom: 10px;
        left: 10px;
      "
    >
      <dv-border-box-1
        :color="['#fccc66', '#e4a02b']"
        backgroundColor="rgba(228,198,80,.3)"
      >
        <div style="padding: 24px">
          <div style="color: #fccc66; text-align: center">乡镇种植面积占比</div>
          <dv-active-ring-chart
            :config="config"
            style="width: 210px; height: 220px"
          />
          <div style="color: #fccc66; text-align: center; margin-top: 12px">
            企业种植面积排名<span style="font-size: 0.7em">（单位：亩）</span>
          </div>
          <dv-capsule-chart
            :config="config1"
            style="width: 240px; height: 380px"
          />
        </div>
      </dv-border-box-1>
    </div>

    <!-- 右上 -->
    <div
      style="
        position: absolute;
        width: 410px;
        height: 540px;
        top: 0;
        right: 10px;
      "
    >
      <dv-border-box-1 backgroundColor="rgba(7,11,32,.7)">
        <p
          style="
            color: #fccc66;
            font-size: 18px;
            padding: 20px 0 8px 24px;
            margin: 0;
          "
        >
          全省种苗与技术辐射
        </p>
        <p
          style="
            color: #9cd9fc;
            padding: 0 24px 0 24px;
            margin: 0 0 -20px 0;
            font-size: 16px;
            margin: 0 0 -45px 0;
          "
        >
          围绕着做大做强长丰草莓品牌规划，通过种苗供应、草莓标准生产模式输出等方式，立足长丰，辐射带动淮南、阜阳、定远、六安等周边县市共同发展草莓业，形成特色化草莓产业集成区。
        </p>
        <div style="text-align: center">
          <dv-flyline-chart-enhanced
            :config="configFly2"
            style="width: 360px; margin: 0 auto; height: 455px"
          />
        </div>
      </dv-border-box-1>
    </div>

    <!-- 右下 -->
    <div
      style="
        position: absolute;
        width: 588px;
        height: 400px;
        bottom: 10px;
        right: 10px;
      "
    >
      <dv-border-box-1 backgroundColor="rgba(7,11,32,.7)">
        <p
          style="
            color: #fccc66;
            font-size: 18px;
            padding: 20px 0 8px 24px;
            margin: 0;
          "
        >
          全国种苗与技术输出
        </p>
        <p
          style="
            color: #9cd9fc;
            padding: 0 24px 0 24px;
            margin: 0 0 -20px 0;
            font-size: 16px;
          "
        >
          全县建立4处脱毒组培中心，草莓原原种苗繁育能力100万株以上，育苗面积近4万亩，满足全国30万亩草莓种植需求。连续成功举办二十届草莓文化节，长丰草莓热销北京、天津、南京、上海、深圳及东北等地。形成辐射全国的产业格局。
        </p>
        <dv-flyline-chart-enhanced
          :config="configFly1"
          style="width: 460px; margin: 0 auto; height: 300px"
        />
      </dv-border-box-1>
    </div>
  </div>
</template>

<script>
import map from './IndexMap.js'
export default {
  name: 'IndustryIndex',
  data() {
    return {
      config: {
        data: [
          { name: '水湖镇', value: 7000 },
          { name: '下塘镇', value: 201 },
          { name: '陶楼镇', value: 472 },
          { name: '庄墓镇', value: 768 },
          { name: '吴山镇', value: 641 },
          { name: '杨庙镇', value: 1626 },
          { name: '造甲乡', value: 243 },
          { name: '义井镇', value: 936 },
          { name: '杜集镇', value: 604 },
          { name: '左店镇', value: 4000 },
          { name: '罗塘乡', value: 5000 },
          { name: '朱巷镇', value: 394 },
          { name: '双凤开发区', value: 206 },
        ],
        lineWidth: 10,
        radius: '85%',
        activeRadius: '95%',
      },
      config1: {
        data: [
          { name: '田峰', value: 365 },
          { name: '艳九天', value: 267 },
          { name: '勤丰果蔬', value: 173 },
          { name: '蝶恋花', value: 155 },
          { name: '上海佳莓', value: 47 },
          { name: '罗塘众鑫', value: 55 },
          { name: '罗塘诚信', value: 45 },
          { name: '罗塘品辰', value: 28 },
        ],
      },
      configFly1: {
        points: [
          {
            name: '长丰',
            coordinate: [0.668, 0.54],
            halo: { show: true },
            icon: { src: 'berry-icon.png', width: 42, height: 32 },
            text: { show: false },
          },
          { name: '山东', coordinate: [0.693, 0.393], text: { show: true } },
          { name: '河南', coordinate: [0.617, 0.49], text: { show: true } },
          { name: '湖北', coordinate: [0.573, 0.54], text: { show: true } },
          { name: '湖南', coordinate: [0.574, 0.681], text: { show: true } },
          { name: '云南', coordinate: [0.38, 0.829], text: { show: true } },
          { name: '辽宁', coordinate: [0.776, 0.24], text: { show: true } },
          { name: '内蒙古', coordinate: [0.584, 0.209], text: { show: true } },
          { name: '西安', coordinate: [0.5329, 0.424], text: { show: true } },
          { name: '太原', coordinate: [0.562, 0.309], text: { show: true } },
          { name: '北京', coordinate: [0.6634, 0.25], text: { show: true } },
          { name: '天津', coordinate: [0.677, 0.29], text: { show: true } },
          { name: '上海', coordinate: [0.75, 0.58], text: { show: true } },
          { name: '深圳', coordinate: [0.61, 0.87], text: { show: true } },
          { name: '南京', coordinate: [0.6994, 0.5822], text: { show: true } },
        ],
        lines: [
          { target: '山东', source: '长丰' },
          { target: '河南', source: '长丰' },
          { target: '湖北', source: '长丰' },
          { target: '湖南', source: '长丰' },
          { target: '云南', source: '长丰' },
          { target: '辽宁', source: '长丰' },
          { target: '内蒙古', source: '长丰' },
          { target: '西安', source: '长丰' },
          { target: '太原', source: '长丰' },
          { target: '北京', source: '长丰' },
          { target: '天津', source: '长丰' },
          { target: '上海', source: '长丰' },
          { target: '深圳', source: '长丰' },
          { target: '南京', source: '长丰' },
        ],
        bgImgSrc: require('./china.png'),
      },
      configFly2: {
        points: [
          {
            name: '长丰',
            coordinate: [0.52, 0.52],
            halo: { show: true },
            icon: { src: 'berry-icon.png', width: 42, height: 32 },
            text: { show: true },
          },
          { name: '亳州', coordinate: [0.375, 0.2], text: { show: true } },
          { name: '阜阳', coordinate: [0.377, 0.37], text: { show: true } },
          { name: '宿州', coordinate: [0.481, 0.239], text: { show: true } },
          { name: '六安', coordinate: [0.441, 0.567], text: { show: true } },
          { name: '蚌埠', coordinate: [0.518, 0.365], text: { show: true } },
          { name: '芜湖', coordinate: [0.614, 0.63], text: { show: true } },
          { name: '安庆', coordinate: [0.496, 0.717], text: { show: true } },
          { name: '滁州', coordinate: [0.591, 0.466], text: { show: true } },
        ],
        lines: [
          { target: '亳州', source: '长丰' },
          { target: '阜阳', source: '长丰' },
          { target: '宿州', source: '长丰' },
          { target: '六安', source: '长丰' },
          { target: '蚌埠', source: '长丰' },
          { target: '芜湖', source: '长丰' },
          { target: '安庆', source: '长丰' },
          { target: '滁州', source: '长丰' },
        ],
        bgImgSrc: require('./anhui.png'),
      },
    }
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.start(this)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/industry/Index.vue